import * as actionTypes from "../../../../actions/actionTypes";
import {updateObject} from "../../../../../utils/utils";
const initialState = {

    loading : true,
    error : null,
    cours: null

};

const etudiantMesCoursFetchCoursStart = (state,action) => {
    return updateObject(state,{
        loading:true,
        error:null,
        cours: null
    });
};

const etudiantMesCoursFetchCoursSuccess = (state,action) => {
    return updateObject(state,{
        loading:false,
        error:null,
        cours: action.payload.cours
    });
};

const etudiantMesCoursFetchCoursFail = (state,action) => {
    return updateObject(state,{
        loading:false,
        error:action.payload.error,
        cours: null
    });
};

const etudiantMesCoursFetchCoursReset = (state,action) => {
    return updateObject(state,initialState);
};



const reducer = (state = initialState,action) => {
    switch (action.type) {

        case actionTypes.ETUDIANT_MES_COURS_FETCH_COURS_START : return etudiantMesCoursFetchCoursStart(state,action);
        case actionTypes.ETUDIANT_MES_COURS_FETCH_COURS_SUCCESS : return etudiantMesCoursFetchCoursSuccess(state,action);
        case actionTypes.ETUDIANT_MES_COURS_FETCH_COURS_FAIL : return etudiantMesCoursFetchCoursFail(state,action);
        case actionTypes.ETUDIANT_MES_COURS_FETCH_COURS_RESET : return etudiantMesCoursFetchCoursReset(state,action);
        default : return state;
    }
};

export default reducer;
